<script setup lang="ts">
import {PropType, ref} from 'vue';
import {type CabKPI, type CabOrganization, type CabReportItem, uuidOf} from 'common';
import AdminReportItemKpi from '@/views/admin/AdminReportItemKpi.vue';
import KpiIcon from '@/views/icons/KpiIcon.vue';
import AdminReportItemMijlpaal from '@/views/admin/AdminReportItemMijlpaal.vue';
import {ElDialog} from 'element-plus';
import KpiMijlpaalStrip from '@/views/admin/KpiMijlpaalStrip.vue';

const props = defineProps({
    kpi: {
        type    : Object as PropType<CabKPI>,
        required: true,
    },
    reportitems: {
        type    : Object as PropType<CabReportItem[]>,
        required: true,
    },
    showOrgTheme: {
        type   : Boolean,
        default: false,
    },
    allOrganizations: {
        type    : Object as PropType<CabOrganization[]>,
        required: true,
    },
});

const kpiOverlayVisible = ref<boolean>(false);

function showKpiOverlay() {
    kpiOverlayVisible.value = true;
}
</script>

<template>
    <div class="flex flex-col items-stretch bg-gray-200 text-gray-900 my-0.5">

        <div class="flex flex-row items-baseline text-lg font-semibold my-0.5 mx-3 cursor-pointer"
             @click="showKpiOverlay()">
            <KpiIcon :kpi="kpi"/>
            {{ kpi.name }}
        </div>

        <div class="flex flex-col items-stretch space-y-3 mb-3 ml-20 mr-1">
            <template v-for="item in reportitems" :key="uuidOf(item)">
                <AdminReportItemMijlpaal
                    v-if="item.isMijlpaal"
                    :item="item"
                    :show-org-theme="props.showOrgTheme"
                />
                <AdminReportItemKpi
                    v-if="!item.isMijlpaal"
                    :item="item"
                    :show-org-theme="props.showOrgTheme"
                />
            </template>
        </div>
    </div>

    <el-dialog
        v-model="kpiOverlayVisible"
        width="90%"
        align-center
        destroy-on-close
        :show-close="false"
        :draggable="true"
    >
        <KpiMijlpaalStrip
            :key="uuidOf(kpi)"
            :kpi="kpi"
            :allOrganizations="allOrganizations"
            :startExpanded="true"
        />

    </el-dialog>

</template>
